// import { WEBSERVER } from './Webserver.js';
// import { PORT } from './Port.js';
import { API } from './API.js';

import axios from 'axios';

const debug = false;

// const url = WEBSERVER + ':3000/api/authenticate/';
// const url = WEBSERVER + ':' + PORT + '/api/authenticate/';

const url = API + '/authenticate/';

class Authenticate {
    static getToken(postdata) {
    return axios.post(url, postdata)
        .then(response => {
            if (debug) console.log('Authenticate.getToken: ',response.data)
            return response.data
        })
        .catch(error => {
            console.log('Authenticate.getToken: ERROR - ',error)
        })
    }
}

export default Authenticate